import { useState } from 'react';
import Logo from '../images/rgglogo2.png'; // prilagodi putanju svom projektu
import {SideNavSections} from '../components/components2';

// Stavke navigacije grupirane po sekcijama. `icon` je SVG path (stroke).
/*const SECTIONS = [
  { key: 'program', title: 'Program', items: [
    { name: 'Nadzorna ploča', code:"DASH", icon: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z' },
    { name: 'Operateri', code:"OPER",icon: 'M16 21v-2a4 4 0 0 0-3-3.87M8 21v-2a4 4 0 0 1 3-3.87M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z' },
    { name: 'Knjige',code:"OPER",icon: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' },
    { name: 'Postavke',code:"OPER",icon: 'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6' },
  ]},
  { key: 'sifarnici', title: 'Šifarnici', items: [
    { name: 'Osobe',code:"OPER",icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' },
    { name: 'Lokacije', code:"OPER", icon: 'M12 21s-6-5.686-6-10a6 6 0 1 1 12 0c0 4.314-6 10-6 10zM12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' },
    { name: 'Klaonice', code:"OPER", icon: 'M3 21V7l9-4 9 4v14M3 21h18M9 21v-6h6v6' },
    { name: 'Države',   code:"OPER", icon: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z' },
    { name: 'Pasmine',  code:"OPER", icon: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01' },
  ]},
  { key: 'registar', title: 'Registar', items: [
    { name: 'Registar', code:"OPER", icon: 'M9 4h6a2 2 0 0 1 2 2H7a2 2 0 0 1 2-2zM7 6H5v15h14V6h-2M9 12h6M9 16h6' },
    { name: 'Dolasci',  code:"OPER", icon: 'M12 3v12M7 10l5 5 5-5M5 21h14' },
    { name: 'Odlasci',  code:"OPER", icon: 'M12 21V9M7 14l5-5 5 5M5 3h14' },
    { name: 'Izlučenja',code:"OPER", icon: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM8 12h8' },
    { name: 'Popisi goveda', code:"OPER", icon: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01' },
    { name: 'Specifikacije', code:"OPER", icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5' },
    { name: 'Putnice (OCR)', code:"OPER", icon: 'M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M7 12h10' },
  ]},
];
*/
const Icon = ({ d, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" style={{ flex: `0 0 ${size}px` }}>
    <path d={d} />
  </svg>
);

const SideNav2 = ({selectedMenu}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKey, setOpenKey] = useState('program'); // samo jedna sekcija otvorena
  const [selected, setSelected] = useState('Nadzorna ploča');
  const [hover, setHover] = useState(null); // ključ stavke/sekcije iznad koje je miš

  const pick = (name,code) => { setSelected(name); selectedMenu(code); };
  const toggleSection = (key) => setOpenKey((cur) => (cur === key ? null : key));

  // ---------- PROŠIRENI PRIKAZ ----------
  if (!collapsed) {
    return (
      <div style={{ width: 272, flex: '0 0 272px', background: '#fafafa', borderRight: '1px solid #e8e8e8',
                    display: 'flex', flexDirection: 'column', height: '100%',
                    fontFamily: "'Source Sans 3', system-ui, sans-serif", boxSizing: 'border-box' }}>

        {/* zaglavlje */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 14px 4px' }}>
          <img src={Logo} alt="Registar Goveda"
               style={{ height: 44, width: 'auto', maxWidth: 170, objectFit: 'contain', display: 'block' }} />
          <div onClick={() => setCollapsed(true)} title="Sažmi"
               style={{ cursor: 'pointer', width: 32, height: 32, borderRadius: 6, display: 'flex', alignItems: 'center',
                        justifyContent: 'center', color: '#6b6b6b', background: hover === '__collapse' ? '#f0f0f0' : 'transparent' }}
               onMouseEnter={() => setHover('__collapse')} onMouseLeave={() => setHover(null)}>
            <Icon d="M15 18l-6-6 6-6" />
          </div>
        </div>

        {/* akordeon */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px 12px' }}>
          {SideNavSections.map((section) => (
            <div key={section.key} style={{ marginBottom: 8 }}>
              <div onClick={() => toggleSection(section.key)}
                   onMouseEnter={() => setHover('sec:' + section.key)} onMouseLeave={() => setHover(null)}
                   style={{ display: 'flex', alignItems: 'center', padding: '9px 8px 9px 10px', borderRadius: 7, cursor: 'pointer',
                            background: hover === 'sec:' + section.key ? '#f0f0f0' : 'transparent' }}>
                <span style={{ flex: 1, textAlign: 'left', fontSize: 11, fontWeight: 700, letterSpacing: '1.1px',
                               textTransform: 'uppercase', color: '#080101' }}>{section.title}</span>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9a9a9a" strokeWidth="2.4"
                     strokeLinecap="round" strokeLinejoin="round"
                     style={{ transition: 'transform .2s ease', transform: openKey === section.key ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>

              {openKey === section.key && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '6px 0 8px' }}>
                  {section.items.map((it) => {
                    const on = it.name === selected;
                    const hot = hover === 'it:' + it.name;
                    return (
                      <div key={it.name} onClick={() => pick(it.name,it.code)}
                           onMouseEnter={() => setHover('it:' + it.name)} onMouseLeave={() => setHover(null)}
                           style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 11,
                                    padding: '9px 12px 9px 15px', borderRadius: 9, cursor: 'pointer', fontSize: 14,
                                    transition: 'background .15s ease, color .15s ease',
                                    background: on ? '#ededed' : (hot ? '#f0f0f0' : 'transparent'),
                                    color: on ? '#1a1a1a' : '#5a5a5a', fontWeight: on ? 600 : 500 }}>
                        <span style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: 3,
                                       height: 17, borderRadius: '0 3px 3px 0', background: '#1f1f1f',
                                       opacity: on ? 1 : 0, transition: 'opacity .15s ease' }} />
                        <Icon d={it.icon} />
                        <span>{it.name}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* podnožje */}
        <div style={{ padding: '14px 16px 18px', borderTop: '1px solid #eee', display: 'flex',
                      flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <div style={{ display: 'flex', fontWeight: 700, fontSize: 14, letterSpacing: '.5px' }}>
            <span style={{ color: '#a01818' }}>S</span><span style={{ color: '#1a1a1a' }}>PIN</span>
            <span style={{ color: '#a01818' }}>B</span><span style={{ color: '#1a1a1a' }}>IT</span>
          </div>
          <div style={{ fontSize: 11, color: '#6b6b6b', marginTop: 3 }}>Svetokriška ulica 28, Križevci</div>
          <div style={{ fontSize: 10, color: '#999', marginTop: 1 }}>spinbit.solutions@gmail.com</div>
          <div style={{ fontSize: 10, color: '#999' }}>+385 91 4591 763</div>
        </div>
      </div>
    );
  }

  // ---------- SAŽETI PRIKAZ ----------
  return (
    <div style={{ width: 64, flex: '0 0 64px', background: '#222426', display: 'flex', flexDirection: 'column',
                  alignItems: 'center', height: '100%', padding: '12px 0', boxSizing: 'border-box',
                  fontFamily: "'Source Sans 3', system-ui, sans-serif" }}>
      <div onClick={() => setCollapsed(false)} title="Proširi"
           onMouseEnter={() => setHover('__expand')} onMouseLeave={() => setHover(null)}
           style={{ cursor: 'pointer', width: 38, height: 38, borderRadius: 8, display: 'flex', alignItems: 'center',
                    justifyContent: 'center', color: '#e2e2e2', marginBottom: 14,
                    background: hover === '__expand' ? 'rgba(255,255,255,.12)' : 'transparent' }}>
        <Icon d="M9 18l6-6-6-6" size={20} />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center', overflowY: 'auto', width: '100%' }}>
        {SideNavSections.flatMap((s) => s.items).map((it) => {
          const on = it.name === selected;
          const hot = hover === 'nit:' + it.name;
          return (
            <div key={it.name} onClick={() => pick(it.name,it.code)} title={it.name}
                 onMouseEnter={() => setHover('nit:' + it.name)} onMouseLeave={() => setHover(null)}
                 style={{ cursor: 'pointer', width: 40, height: 40, borderRadius: 8, display: 'flex', alignItems: 'center',
                          justifyContent: 'center', color: on ? '#fff' : '#9a9a9a',
                          background: on ? 'rgba(255,255,255,.16)' : (hot ? 'rgba(255,255,255,.12)' : 'transparent') }}>
              <Icon d={it.icon} size={19} />
            </div>
          );
        })}
      </div>
      <div style={{ fontWeight: 700, fontSize: 12, color: '#ccc', letterSpacing: '.5px' }}>SB</div>
    </div>
  );
};

export default SideNav2;